import { useEffect } from 'react'
import { Outlet, useMatches, Navigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import { useAuth } from '@App/components/AuthProvider/AuthProvider'
import { setActiveProject } from '@App/pages/MissionSetup/mission-setup.slice'
import { fetchAllMissionProjects } from '@services/data.service'
import Appbar from '@App/components/Appbar/Appbar'
import Nav from '@App/components/Nav/Nav'

import './nav-wrapper.styl'

function NavWrapper() {
  const { user, isLoading } = useAuth()
  const matches = useMatches()
  const dispatch = useDispatch()
  const { name } = matches[matches.length - 1]?.handle || {}
  const activeProject = useSelector(state => state.missionSetup.activeProject)

  const { data: projects } = useQuery({
    queryKey: ['projects'],
    queryFn: fetchAllMissionProjects,
  })

  useEffect(() => {
    document.title = name ? `MOBVEC | ${name}` : 'MOBVEC'
  }, [name])

  useEffect(() => {
    if (!activeProject && projects?.length > 0) {
      const barcelonaProject = projects.find(project => project.id === 'Barcelona')
      dispatch(setActiveProject(barcelonaProject || projects[0]))
    }
  }, [activeProject, dispatch, projects])

  if (isLoading) return null
  if (!user) return <Navigate to="/login" replace />

  return (
    <div className="nav-wrapper">
      <Appbar projects={projects} />
      <div className="nav-wrapper__body">
        <Nav />
        {activeProject && <Outlet />}
      </div>
    </div>
  )
}

export default NavWrapper
